module.exports = __webpack_public_path__ + "static/img/notFound (1).c9c9610.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/notFound (1).gif
// module id = 05xg
// module chunks = 209